export const sidebarSlots = [
  'body',
  'card',
  'cardSubtext',
  'progressCircle',
  'progressRange',
  'progressTrack',
  'root',
  'separator',
];
